import React from 'react';
import Icon from '../../../components/AppIcon';

const ArticleStats = ({ articles }) => {
  const calculateStats = () => {
    const total = articles?.length;
    const published = articles?.filter(a => a?.status === 'published')?.length;
    const draft = articles?.filter(a => a?.status === 'draft')?.length;
    const scheduled = articles?.filter(a => a?.status === 'scheduled')?.length;
    
    const categories = {
      news: articles?.filter(a => a?.category === 'news')?.length,
      events: articles?.filter(a => a?.category === 'events')?.length,
      announcements: articles?.filter(a => a?.category === 'announcements')?.length
    };

    const totalViews = articles?.reduce((sum, article) => sum + (article?.views || 0), 0);
    const avgViews = total > 0 ? Math.round(totalViews / total) : 0;

    return {
      total,
      published,
      draft,
      scheduled,
      categories,
      totalViews,
      avgViews
    };
  };

  const stats = calculateStats();

  const statCards = [
    {
      label: 'Total Articles',
      value: stats?.total,
      icon: 'FileText',
      color: 'text-foreground',
      bgColor: 'bg-card'
    },
    {
      label: 'Published',
      value: stats?.published,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Draft',
      value: stats?.draft,
      icon: 'Edit3',
      color: 'text-muted-foreground',
      bgColor: 'bg-muted/30'
    },
    {
      label: 'Scheduled',
      value: stats?.scheduled,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Total Views',
      value: stats?.totalViews?.toLocaleString(),
      icon: 'Eye',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      label: 'Avg. Views',
      value: stats?.avgViews?.toLocaleString(),
      icon: 'TrendingUp',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className={`${stat?.bgColor} border border-border rounded-lg p-4 transition-all duration-200 hover:shadow-elevation-1`}
        >
          <div className="flex items-center justify-between mb-2">
            <Icon 
              name={stat?.icon} 
              size={20} 
              className={stat?.color}
            />
          </div>
          
          <div>
            <p className="text-2xl font-bold text-foreground mb-1">
              {stat?.value}
            </p>
            <p className="text-xs text-muted-foreground font-medium">
              {stat?.label}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ArticleStats;